import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import { observer } from 'mobx-react'
import React from 'react'
import {
  JobScopeCustomItem,
  JobScopeItemSource,
} from '../../UpdateJobScopeViewModel'
import cx from 'classnames'
import styles from './JobScopeCustomItem.sass'
import { asNumber } from 'utils/number-util'

export default observer(function JobScopeCustomItem({
  item,
  remove,
  dataTestId,
}: {
  item: JobScopeCustomItem
  remove: (key: string) => void
  dataTestId: string
}) {
  const isFromJobScope = item.source === JobScopeItemSource.Job

  return (
    <div
      className={styles.customItemContainer}
      data-test="job-scope-update-item"
    >
      <IconButton
        className={styles.removeCustomItemButton}
        onClick={() => remove(item.id)}
        dataTest={`job-scope-update-custom-remove-button-${dataTestId}`}
      >
        <Icon name="close" size={24} />
      </IconButton>

      <div className={styles.textContainer}>
        <div className={styles.title}>{item.name}</div>
        <div className={styles.priceContainer}>
          <div className={styles.price}>{'$' + item.price}</div>
          <div className={styles.priceSeparator}>|</div>
          <div className={styles.price}>{'$' + item.proPrice}</div>
        </div>
      </div>

      <div
        className={styles.currentQuantityContainer}
        data-test={`job-scope-update-custom-current-quantity-${dataTestId}`}
      >
        {item.currentQuantity}
      </div>

      <div
        className={cx(
          styles.customItemQuantityContainer,
          item.validation.getError('currentQuantity') && styles.hasError
        )}
      >
        <IconButton onClick={item.decrementQuantity} disabled={isFromJobScope}>
          <Icon name="subtract" size={16} />
        </IconButton>

        <input
          key="quantity"
          type="number"
          min="1"
          className={cx(styles.input, styles.customItemQuantity)}
          value={item.newQuantity}
          onChange={(e) => item.setQuantity(asNumber(e.target.value))}
          data-test={`job-scope-update-custom-quantity-${dataTestId}`}
          disabled={isFromJobScope}
        />

        <IconButton onClick={item.incrementQuantity} disabled={isFromJobScope}>
          <Icon name="add" size={16} />
        </IconButton>
      </div>
    </div>
  )
})
